module.exports = __webpack_public_path__ + "img/5.ef42ff01.jpg";